import React, { useEffect, useRef, useCallback, memo } from 'react';

const Turnstile = memo(({ sitekey, onVerify }) => {
  const divRef = useRef(null);
  const widgetId = useRef(null);
  const callbackRef = useRef(onVerify);

  // Keep the latest callback in ref to prevent re-renders
  useEffect(() => {
    callbackRef.current = onVerify;
  }, [onVerify]);

  const validateToken = useCallback((token) => {
    callbackRef.current(token);
  }, []); // No dependencies since we use callbackRef

  useEffect(() => {
    // Only render if we don't already have a widget
    if (window.turnstile && divRef.current && !widgetId.current) {
      widgetId.current = window.turnstile.render(divRef.current, {
        sitekey: sitekey,
        callback: validateToken,
        'refresh-expired': 'auto'
      });
    }

    return () => {
      if (widgetId.current) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    };
  }, [sitekey, validateToken]); // validateToken is now stable

  return <div ref={divRef} />;
});

Turnstile.displayName = 'Turnstile';

export default Turnstile;